export default __webpack_public_path__ + "static/B0134-10ed2a49b6a09dd53f38f87ecfd8ce0d.png";